import { createFileRoute, notFound } from "@tanstack/react-router";
import { templatePreviewHead } from "../components/template-preview/head";
import { TemplatePreviewPage } from "../components/template-preview/template-preview-page";
import { keepSearch, searchText } from "../lib/search";
import { loadTemplatePreview } from "../server/template-preview";

/**
 * One page of a template's example (/use-cases/<slug>/preview/library, /join, /merch/products/…):
 * the pages its home links to. Anything else is a 404.
 */
export const Route = createFileRoute("/use-cases/$slug_/preview/$")({
  validateSearch: keepSearch,
  loaderDeps: ({ search }) => ({
    theme: searchText(search, "theme"),
    look: searchText(search, "look"),
    hero: searchText(search, "hero") === "1",
  }),
  loader: async ({ params, deps }) => {
    const preview = await loadTemplatePreview({
      data: {
        slug: params.slug,
        page: params._splat ?? "",
        theme: deps.theme,
        look: deps.look,
        hero: deps.hero,
      },
    });
    if (!preview) throw notFound();
    return preview;
  },
  head: ({ loaderData }) => templatePreviewHead(loaderData),
  component: TemplatePreviewSubpage,
});

function TemplatePreviewSubpage() {
  return <TemplatePreviewPage preview={Route.useLoaderData()} />;
}
